export default __webpack_public_path__ + "static/media/avatar_179.f373a1b0.png";